export const tickerItems = [
  "今日入口状态正常 · 主站与备用线均可访问",
  "建议立刻收藏本页，换域名时这里永远找得到",
  "新增镜像线路 mirror-03，移动端访问速度更快",
  "本周热门话题：剧组路透、综艺名场面、演唱会退票",
  "遇到打不开先别急，先看『打不开怎么办』三步排查",
];

export const entryLines = [
  {
    id: "main",
    name: "主站入口",
    code: "hl-main",
    status: "online",
    statusText: "畅通",
    latency: "38ms",
    region: "亚太 · 移动优选",
    note: "日常优先使用，速度最快",
    highlight: true,
  },
  {
    id: "backup",
    name: "备用线路 B",
    code: "hl-backup-b",
    status: "online",
    statusText: "畅通",
    latency: "72ms",
    region: "全球 · 通用",
    note: "主站波动时自动切换",
    highlight: false,
  },
  {
    id: "mirror",
    name: "镜像线路 03",
    code: "hl-mirror-03",
    status: "busy",
    statusText: "繁忙",
    latency: "164ms",
    region: "欧洲 · 备用",
    note: "高峰时段偶尔排队",
    highlight: false,
  },
  {
    id: "mobile",
    name: "移动专线",
    code: "hl-mobile",
    status: "online",
    statusText: "畅通",
    latency: "45ms",
    region: "亚太 · 4G/5G",
    note: "手机流量访问更稳",
    highlight: false,
  },
];

export const stayFoundSteps = [
  {
    step: "01",
    title: "先收藏这一页",
    desc: "把「黑料入口」加入浏览器书签或发送到自己的收藏夹，域名怎么换，这里都留着最新地址。",
    icon: "ri-bookmark-3-line",
  },
  {
    step: "02",
    title: "记下两个备用线",
    desc: "别只记一条路。主站 + 备用线路一起存，其中一条打不开时，另一条也能马上接上。",
    icon: "ri-route-line",
  },
  {
    step: "03",
    title: "换网络再试一次",
    desc: "同一时刻 WiFi 不通就切流量，流量不通就切 WiFi，多数『打不开』一步就能解决。",
    icon: "ri-signal-tower-line",
  },
];

export const topicTags = [
  { id: "all", label: "全部话题" },
  { id: "drama", label: "综艺名场面" },
  { id: "stage", label: "舞台与演出" },
  { id: "screen", label: "影视路透" },
  { id: "airport", label: "行程与机场" },
  { id: "award", label: "颁奖与盘点" },
];

export const hotTopics = [
  {
    id: "t1",
    rank: "01",
    category: "drama",
    tag: "综艺名场面",
    title: "新一季团综播出，这段即兴接话被剪进片尾彩蛋",
    excerpt: "录制现场临时改词，嘉宾接得干脆利落，正片没放完整版本，彩蛋一上线就被剪成短视频刷屏。",
    heat: "12.8 万热度",
    time: "2 小时前",
    image:
      "https://readdy.ai/api/search-image?query=minimal%20abstract%20warm%20red%20stage%20spotlight%20texture%2C%20soft%20gradient%20backdrop%2C%20no%20people%2C%20editorial%20magazine%20cover%20feel%2C%20clean%20simple%20composition&width=480&height=320&seq=hl-topic-drama-01&orientation=landscape",
  },
  {
    id: "t2",
    rank: "02",
    category: "stage",
    tag: "舞台与演出",
    title: "巡演加场消息落地，主办方公布第二批城市名单",
    excerpt: "首批门票十分钟售罄后官方松口加场，新增城市以中西部为主，退票窗口和实名规则同步更新。",
    heat: "9.4 万热度",
    time: "4 小时前",
    image:
      "https://readdy.ai/api/search-image?query=warm%20amber%20abstract%20concert%20lights%20bokeh%20texture%2C%20deep%20brown%20background%2C%20no%20people%2C%20minimal%20editorial%20graphic%2C%20clean%20composition&width=480&height=320&seq=hl-topic-stage-02&orientation=landscape",
  },
  {
    id: "t3",
    rank: "03",
    category: "screen",
    tag: "影视路透",
    title: "剧组外景连拍三天，主创同框画面被路人拍下",
    excerpt: "新剧进入实景拍摄阶段，连续三天在同一个取景地收工，路透照片里主演造型和定妆照差别不小。",
    heat: "8.1 万热度",
    time: "6 小时前",
    image:
      "https://readdy.ai/api/search-image?query=muted%20terracotta%20abstract%20film%20grain%20texture%2C%20warm%20beige%20backdrop%2C%20no%20people%2C%20minimal%20editorial%20graphic%20style%2C%20clean%20simple%20composition&width=480&height=320&seq=hl-topic-screen-03&orientation=landscape",
  },
  {
    id: "t4",
    rank: "04",
    category: "airport",
    tag: "行程与机场",
    title: "连续两周行程满档，机场生图状态引讨论",
    excerpt: "通告排得密集，机场图连着几天被拍，评论区一半在夸状态，一半在心疼行程太赶。",
    heat: "6.7 万热度",
    time: "9 小时前",
    image:
      "https://readdy.ai/api/search-image?query=soft%20dusty%20rose%20abstract%20paper%20texture%2C%20warm%20neutral%20background%2C%20no%20people%2C%20minimal%20editorial%20graphic%2C%20clean%20composition&width=480&height=320&seq=hl-topic-airport-04&orientation=landscape",
  },
];

export const newsFeed = [
  { id: "n1", time: "18:42", tag: "综艺名场面", title: "团综彩蛋完整版上线，评论区集体回看第三遍", hot: true },
  { id: "n2", time: "17:05", tag: "舞台与演出", title: "巡演加场第二批城市公布，退票规则一并更新", hot: true },
  { id: "n3", time: "15:30", tag: "影视路透", title: "新剧实景连拍三天，路透造型和定妆照差别不小", hot: false },
  { id: "n4", time: "13:58", tag: "颁奖与盘点", title: "年度盘点榜单一出，前十里有两部冷门作品冲进来", hot: false },
  { id: "n5", time: "11:20", tag: "行程与机场", title: "机场生图连拍一周，粉丝把行程表整理成了时间线", hot: false },
  { id: "n6", time: "09:47", tag: "影视路透", title: "预告片只放了三十秒，帧数党已经拆出隐藏角色", hot: false },
  { id: "n7", time: "08:15", tag: "综艺名场面", title: "上一季名场面被翻出来重剪，播放量又涨了一波", hot: false },
];

export const tagWall = [
  "综艺名场面",
  "舞台与演出",
  "影视路透",
  "行程与机场",
  "颁奖与盘点",
  "片尾彩蛋",
  "定妆照对比",
  "路透合集",
  "退票规则",
  "实名入场",
  "预告拆帧",
  "行程时间线",
  "剧组开机",
  "演唱会加场",
  "短视频二创",
  "评论区考古",
  "冷门作品",
  "榜单盘点",
];

export const accessTips = [
  {
    icon: "ri-wifi-off-line",
    title: "换个网络先试",
    desc: "当前 WiFi 打不开时，直接切到手机流量；反过来也一样，大多数情况一步就能进。",
  },
  {
    icon: "ri-refresh-line",
    title: "清一下浏览器缓存",
    desc: "旧缓存偶尔会卡住页面，清理缓存或换无痕窗口重新打开，比反复刷新更有效。",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "换回默认 DNS",
    desc: "手动改过 DNS 的浏览器偶尔会解析异常，恢复成自动获取或者换成公共 DNS 再试。",
  },
  {
    icon: "ri-global-line",
    title: "换一条备用线路",
    desc: "上面入口板里的四条线是互不影响的，主站繁忙时直接切备用线，别在原地干等。",
  },
];

export const faqs = [
  {
    q: "黑料入口打不开怎么办？",
    a: "先别反复刷新。按『换个网络 → 清缓存 → 换备用线路』的顺序排查，多数情况一两分钟就能恢复；都不行就收藏本页等新地址更新。",
  },
  {
    q: "页面上的入口按钮为什么点了没反应？",
    a: "本页是一个单页展示样板，入口按钮和状态板目前只做展示效果，用来演示排版和交互。正式接入线路后即可直接跳转。",
  },
  {
    q: "怎么保证下次还找得到这里？",
    a: "最稳的做法是把本页加入书签，同时记住一条备用线路。域名更新会在页顶滚动条里第一时间同步。",
  },
  {
    q: "现在浏览的内容都是哪里来的？",
    a: "本页展示的话题与标题为演示用示例内容，仅用于呈现页面结构，不代表任何真实事件或人物。",
  },
];

export const navLinks = [
  { id: "entries", label: "入口状态" },
  { id: "guide", label: "防走失" },
  { id: "topics", label: "热门话题" },
  { id: "feed", label: "爆料速览" },
  { id: "faq", label: "常见问题" },
];